"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotPersonalDataSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
/** Information that does not belong to an individual */
exports.NotPersonalDataSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback subcategory */
    NotPersonalData: 'NOT_PERSONAL_DATA',
});
//# sourceMappingURL=notPersonalData.js.map